import { Card } from 'antd';

/**
 * Олон алхамт урсгалуудын хэсгүүдийг нэг ижил харагдацтай болгох бүрхүүл:
 * `Card size="middle"` + зүүн талд өнгөт дүрстэй гарчиг.
 *
 * Хэрэглэдэг дэлгэцүүд:
 *   - views/orderDelivery/Add (Хүргэлтийн захиалга үүсгэх)
 *   - views/orders (Татан авалтын захиалга үүсгэх)
 *
 * Барааны дэлгэцүүд дээр үүнээс салаалсан хуучин хувилбар байгаа
 * (views/product/components/SectionCard.js) — харагдацыг өөрчлөх бол
 * хоёуланг зэрэг харна.
 */

/** Брэндийн цайвар хөх — гарчгийн дүрсэнд */
const ICON_COLOR = '#2FA1D9';

/** Аппын бусад гадаргуутай ижил зураасны өнгө */
const BORDER_COLOR = '#f1f2f4';

const iconStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  // Гарчиг урт байж мөр доош бөхөхөд дүрс агшихгүй
  flex: 'none',
  width: 28,
  height: 28,
  borderRadius: 8,
  fontSize: 15,
  color: ICON_COLOR,
  background: 'rgba(47, 161, 217, 0.1)',
};

const SectionCard = ({ icon, title, action, children, style, styles, ...cardProps }) => (
  <Card
    size="middle"
    title={
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
        {icon && <span style={iconStyle}>{icon}</span>}
        {/* Гарчиг урт байвал таслахгүй, доош бөхнө (жижиг дэлгэц) */}
        <span style={{ whiteSpace: 'normal' }}>{title}</span>
      </span>
    }
    extra={action}
    style={{ borderColor: BORDER_COLOR, boxShadow: '0 1px 2px rgba(16, 22, 26, 0.04)', ...style }}
    styles={{ ...styles, header: { borderBottomColor: BORDER_COLOR, ...styles?.header } }}
    {...cardProps}
  >
    {children}
  </Card>
);

export default SectionCard;
